import React from 'react';

const ChevronIcon = ({ backgroundColor, iconColor, ...iconProps }) => (
  <svg
    viewBox="0 0 15 9"
    xmlns="http://www.w3.org/2000/svg"
    {...{ height: 9, width: 15, ...iconProps }}
  >
    <path
      d="m75 4 7.001 7 6.999-7"
      fill="none"
      stroke={iconColor}
      transform="matrix(-1 0 0 1 90 -3)"
    />
  </svg>
);

export default ChevronIcon;
